module.exports = __webpack_public_path__ + "static/img/1.176c7278.png";